import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { Route, Switch } from 'react-router';

import _Breadcrumbs, { Item as BreadcrumbsItem } from '../component/compound/Breadcrumbs';
import { Consumer as StateConsumer } from '../context/state';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const Breadcrumbs = ({ className }: Props) => (
  <StateConsumer>
    {(state) => (
      <Switch>
        <Route exact sensitive path="/settings">
          {() => (
            <_Breadcrumbs className={className}>
              <BreadcrumbsItem key="settings">
                <FormattedMessage id="breadcrumbs.settings" />
              </BreadcrumbsItem>
            </_Breadcrumbs>
          )}
        </Route>
        <Route exact sensitive path="/projects">
          {() => (
            <_Breadcrumbs className={className}>
              <BreadcrumbsItem key="projects">
                <FormattedMessage id="breadcrumbs.projects" />
              </BreadcrumbsItem>
            </_Breadcrumbs>
          )}
        </Route>
        <Route exact sensitive path="/projects/:projectId/creations/:creationId">
          {() => (
            <_Breadcrumbs className={className}>
              <BreadcrumbsItem href="/" key="projects">
                <FormattedMessage id="breadcrumbs.projects" />
              </BreadcrumbsItem>

              {state.project.project ? (
                <BreadcrumbsItem href={`/projects/${state.project.project.id}`} key="projects">
                  {state.project.project.title}
                </BreadcrumbsItem>
              ) : (
                <BreadcrumbsItem key="projects">
                  <FormattedMessage id="breadcrumbs.loading" />
                </BreadcrumbsItem>
              )}

              <BreadcrumbsItem key="creation">
                <FormattedMessage id="breadcrumbs.creation" />
              </BreadcrumbsItem>
            </_Breadcrumbs>
          )}
        </Route>
        <Route exact sensitive path="/projects/:projectId">
          {() => (
            <_Breadcrumbs className={className}>
              <BreadcrumbsItem href="/" key="projects">
                <FormattedMessage id="breadcrumbs.projects" />
              </BreadcrumbsItem>

              {state.project.project ? (
                <BreadcrumbsItem key="projects">{state.project.project.title}</BreadcrumbsItem>
              ) : (
                <BreadcrumbsItem key="projects">
                  <FormattedMessage id="breadcrumbs.loading" />
                </BreadcrumbsItem>
              )}
            </_Breadcrumbs>
          )}
        </Route>
        <Route exact sensitive path="/projects/:projectId/diff/">
          {() => (
            <_Breadcrumbs className={className}>
              <BreadcrumbsItem href="/" key="projects">
                <FormattedMessage id="breadcrumbs.projects" />
              </BreadcrumbsItem>

              {state.project.project ? (
                <BreadcrumbsItem href={`/projects/${state.project.project.id}`} key="projects">
                  {state.project.project.title}
                </BreadcrumbsItem>
              ) : (
                <BreadcrumbsItem key="projects">
                  <FormattedMessage id="breadcrumbs.loading" />
                </BreadcrumbsItem>
              )}

              <BreadcrumbsItem key="creation">
                <FormattedMessage id="breadcrumbs.diff" />
              </BreadcrumbsItem>
            </_Breadcrumbs>
          )}
        </Route>
        <Route exact sensitive path="/offers">
          {() => (
            <_Breadcrumbs className={className}>
              <BreadcrumbsItem key="offers">
                <FormattedMessage id="breadcrumbs.offers" />
              </BreadcrumbsItem>
            </_Breadcrumbs>
          )}
        </Route>
        <Route exact sensitive path="/offers/:offerId">
          {() => (
            <_Breadcrumbs className={className}>
              <BreadcrumbsItem href="/offers" key="offers">
                <FormattedMessage id="breadcrumbs.offers" />
              </BreadcrumbsItem>

              {state.offer.offer ? (
                <BreadcrumbsItem key="offers">{state.offer.offer.name}</BreadcrumbsItem>
              ) : (
                <BreadcrumbsItem key="offers">
                  <FormattedMessage id="breadcrumbs.loading" />
                </BreadcrumbsItem>
              )}
            </_Breadcrumbs>
          )}
        </Route>
      </Switch>
    )}
  </StateConsumer>
);

export default Breadcrumbs;
